<template>
  <div class="home">
    <div v-loading="loading" element-loading-text="加载中..." style="min-height: 35vw;" v-if="!error">
      <!-- swiper -->
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-item" v-for='item of swiperList' :key='item.Id'>
          <a :href="item.Addr" target="_blank" v-if="item.IndexImagesLinkType == 0">
            <img class='swiper-img' :src='item.srcUrl' alt="banner图片" />
          </a>
          <router-link :to="{name: 'Detail', query: {id: item.ID}}" v-if="item.IndexImagesLinkType == 1">
            <img class='swiper-img' :src='item.srcUrl' alt="banner图片" />
          </router-link>
          <router-link :to="{name: 'ProductDetail', query: {id: item.ID}}" v-if="item.IndexImagesLinkType == 2">
            <img class='swiper-img' :src='item.srcUrl' alt="banner图片" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
      <!-- 药品讲座 -->
      <div class="medicinePro">
        <h2 class="medicinePro-title">药品讲座
          <router-link class="tomore" to="/chair/ChairList">查看更多&gt;</router-link>
        </h2>
        <div class="s2-swiper">
          <swiper class="swiper-block" :options="swiperOption1" ref="mySwiper1">
            <swiper-slide class="swiper-item swiper-item-small" v-for='item in swiperList1' :key='item.ID'>
              <router-link class="s2-item" :to="{name: 'Detail', query: {id: item.ID}}">
                <div class="s2-item-video">
                  <img :src="item.vdImgSrc"/>
                  <img class="play-video" src="./../../assets/images/ico_play_btn@2x.png"/>
                </div>
                <h4>{{item.Name}}</h4>
                <div class="renwu-item">
                  <div class="renwu-item-left" v-if="item.Lecturer">
                    <img :src="item.Lecturer.docImg"/>
                    <span>{{item.Lecturer.Name}}</span>
                  </div>
                  <p class="renwu-item-right" v-html="item.Lecturer.PersonalProfile"></p>
                </div>
                <div class="function-item">
                  <template v-for="innerItem in item.LectureLibrarys">
                    <span :key="innerItem.ID">{{innerItem.KeyName}}</span>
                  </template>
                  </div>
              </router-link>
            </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
          </swiper>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <!-- 药品库 -->
      <div style="background-color:#fff;">
        <section class="medicineStore">
          <h2 class="medicinePro-title">药品库
            <router-link class="tomore" to="/product/productList">查看更多&gt;</router-link>
          </h2>
          <div class="store-item-block" v-if="pics.length">
            <template v-for="(item,index) in pics">
              <router-link :to="{name: 'ProductList', query: {id: item.ID,text: item.Name}}" class="store-item" tag="div" :key="index">
                <img :src="item.imgSrc"/>
                <div class="store-item-text">
                  <p class="si-i1">{{item.Name}}</p>
                  <!-- <p class="si-i2">MALE HEALTH</p> -->
                  <span class="inter-view">进入 &gt;</span>
                </div>
              </router-link>
            </template>
          </div>
          <!-- 一楼 -->
          <div class="floor-item" style="padding-top:60px;">
              <div class="fllor-item-right">
                <router-link :to="{name:'ProductDetail', query: {id: item.Medicine.ID}}" v-for="(item,index) in medicineRecommendList" :key="index">
                  <product :product="item" :index="index"></product>
                </router-link>
              </div>
            <!-- </div> -->
          </div>
          <!-- 二楼 -->
          <!-- <div class="floor-item">
            <div class="floor-item-pro">
              <div class="floor-item-left">
                <h3>2F 消化道和代谢方面的药物</h3>
                <p class="floor-all-desc">
                  男科用药 / 心脑血管疾病<br/>
                  肝胆用药 / 皮肤用药<br/>
                  肿瘤疾病 / 妇科用药<br/>
                  儿科用药 / 风湿骨痛疾病<br/>
                  神经系统疾病
                </p>
              </div>
              <div class="fllor-item-right">
                <template v-for="item in [1,2,3]">
                  <product :key="item"></product>
                </template>
              </div>
            </div>
          </div> -->
          <!-- 三楼 -->
          <!-- <div class="floor-item" style="border-bottom:none;">
            <div class="floor-item-pro">
              <div class="floor-item-left">
                <h3>3F 消化道和代谢方面的药物</h3>
                <p class="floor-all-desc">
                  男科用药 / 心脑血管疾病<br/>
                  肝胆用药 / 皮肤用药<br/>
                  肿瘤疾病 / 妇科用药<br/>
                  儿科用药 / 风湿骨痛疾病<br/>
                  神经系统疾病
                </p>
              </div>
              <div class="fllor-item-right">
                <template v-for="item in [1,2,3]">
                  <product :key="item"></product>
                </template>
              </div>
            </div>
          </div> -->
          <el-button class="them-btn long-btn" @click="toProductList">进入药品库</el-button>
        </section>
      </div>
      <!-- 新闻 -->
      <div class="newsWrapper">
        <section class="newsPro">
          <h2 class="news-title">临床用药</h2>
          <template v-for="item in news">
            <router-link class="news-flex" :key="item.ID" :to="{name: 'NewsDetail', query: {id: item.ID}}">
              <img class="news-img" :src="item.newsSrc"/>
              <div class="news-center">
                <p class="news-center-title">{{ item.Title}}</p>
                <p class="news-desc">{{item.SecondTitle}}</p>
              </div>
              <p class="date">{{item.time}}</p>
            </router-link>
          </template>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { bannerList, lectureList, medicineRecommendList, newsList, getIndexPicClass} from "@/api/index";
import Product from '@/components/product'
import * as C from '@/utils/const'
  export default {
    data () {
      return {
        swiperOption:{
          pagination: {
            el: '.swiper-pagination'
          },
          loop:true,
          autoplay:2000,
          speed:1000,
        },
        swiperOption1: {
          slidesPerView: 4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          loop:true,
          autoplay:2000,
          speed:1000,
        },
        //三张轮播，使用变量循环
        swiperList:[],
        swiperList1: [],
        error: false,
        banner: [],
        loading: false,
        dialogVisible: false,
        news: [],
        medicineRecommendList: [],
        pics: []
      }  
    },
    methods: {
      getBanner(){
        bannerList({type: 2},true).then(res => {
          this.swiperList = res.Data.map(item => {
            /*
            IndexImagesLinkType 如果是 0 跳转链接
            IndexImagesLinkType 如果是 1 跳转讲座详情 请求后带ID
            IndexImagesLinkType 如果是 2 跳转药品详情 请求后带ID
            */
            item.srcUrl =C.basePath+ item.File.Path.replace("./wwwroot","");
            return item;
          });
        })
      },
      lectureList(){
        lectureList().then(res => {
          this.swiperList1 = res.Data.map(item => {
            item.vdImgSrc = C.basePath+item.Image.Path.replace("./wwwroot","");
            item.Lecturer.docImg = C.setAvatar(item.Lecturer.Photo.Path, item.Lecturer.PhotoUrl)
            return item;
          })
        })
      },
      getMedicineRecommendList(){
        medicineRecommendList().then(res => {
          this.medicineRecommendList = res.Data.map(item => {
            if(item.ImageId!=null)
                        item.imgSrc = C.basePath+ item.Image.Path.replace("./wwwroot","");
                    else
                        item.imgSrc ='DefaultImg.jpg';
            return item
          });
        })
      },
      getNews(){
        newsList().then(res => {
          this.news = res.Data.map(item => {
            item.time = this.$monent(item.CreateTime).format("YY-MM-DD");
            item.newsSrc = C.basePath+ item.Image.Path.replace("./wwwroot","");
            return item;
          })
        })
      },
      getPics(){
        getIndexPicClass().then(res => {
          let pics = []
          for (var i = 0; i< 4; i++) {
            res.Data[i] && pics.push(res.Data[i]);
          }
          this.pics = pics.map(item => {
            item.imgSrc = C.basePath+ item.Image.Path.replace("./wwwroot","");
            return item;
          })
        })
      },
      toProductList(){
        this.$router.push({name: 'ProductList'})
      }
    },
    mounted () {
    },  
    created () {
      this.getBanner();
      this.lectureList();
      this.getMedicineRecommendList();
      this.getNews();
      this.getPics();
    },
    components: {
      swiper,
      swiperSlide,
      Product
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.swiper-container {
  .wrapper{
      overflow:hidden;
      width: 100%;
      height:0;
      padding-bottom:26.6666667%;
      background :#ccc;
  }
  .swiper-item{
    width:100%;
    max-height: 400px;
    overflow: hidden;
  }
  .swiper-item-small{
    width: 280px;
  }
  .swiper-img{
    width:100%;
    max-height: 400px;
  }
  /deep/ .swiper-pagination-bullet{
    width: 50px;
    height: 2px;
    border-radius: 0;
    margin: 0 10px;
    background-color: #fff;
  }
}
.medicinePro{
  background: #F2F6FC;
  padding: 43px 0 24px 0;
  .medicinePro-title{
    width: 1180px;
    margin: 0 auto;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    line-height: 36px;
    color: #0084C4;
    text-indent: 50px;
    background: url('../../assets/images/ico_mic@2x.png')no-repeat left center;
    background-size: 15px auto;
  }
  .s2-swiper{
    margin: 0 auto;
    padding-top: 43px;
  }
}
.s2-item{
  width: 280px;
  .s2-item-video{
    height: 158px;
    position: relative;
    img{
      width: 280px;
      height: 158px;
    }
    .play-video{
      width: 48px;
      height: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  h4{
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    color: #303133;
    padding: 20px 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.s2-swiper{
  width: 1342px;
  margin: 0 auto;
  position: relative;
  .swiper-block{
    width: 1180px;
  }
  .swiper-button-next{
    position: absolute;
    right: 0;
    top: 50%;
    width: 30px;
    height: 40px;
    margin-top: -20px;
    background: url('../../assets/images/ico_right_32x@2x.png')no-repeat center;
    background-size: 17px 32px;
    outline: none;
  }
  .swiper-button-prev{
    position: absolute;
    left: 0;
    top: 50%;
    width: 30px;
    height: 40px;
    margin-top: -20px;
    background: url('../../assets/images/ico_left_32x@2x.png')no-repeat center;
    background-size: 17px 32px;
    outline: none;
  }
}
.renwu-item{
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  .renwu-item-left{
    width: 60px;
    img{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }
    span{
      display: block;
      font-size: 14px;
      line-height: 19px;
      color: #909399;
      height: 19px;
      overflow: hidden;
    }
  }
  .renwu-item-right{
    height: 57px;
    width: 190px;
    font-size: 14px;
    line-height: 19px;
    color: #909399;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
}
.function-item{
  padding: 10px;
  span{
    display: inline-block;
    background-color: #EBEEF5;
    margin-right: 8px;
    color: #909399;
    font-size: 12px;
    line-height: 16px;
    padding: 4px 10px;
    border-radius: 24px;
  }
}
.tomore{
  font-size: 14px;
  line-height: 19px;
  color: #606266;
  float: right;
  font-weight: 400;
  margin-top: 18px;
}
.medicineStore{
  width: 1180px;
  margin: 0 auto;
  padding: 52px 0;
  background: #fff;
  .medicinePro-title{
    width: 1180px;
    margin: 0 auto;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    line-height: 36px;
    color: #0084C4;
    text-indent: 50px;
    background: url('../../assets/images/ico_medicine@2x.png')no-repeat left center;
    background-size: 24px auto;
  }
}
.store-item-block{
  width: 100%;
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
}
.store-item{
  width: 280px;
  height: 120px;
  position: relative;
  .store-item-text{
    width: 280px;
    height: 120px;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
  }
  .inter-view{
    display: block;
    height: 24;
    line-height: 24px;
    width: 68px;
    margin-top: 14px;
    margin-left: 25px;
    background-color: #909DA5;
    color: #fff;
    border-radius: 24px;
    text-align: center;
    font-size: 12px;
  }
  img{
    width: 280px;
    height: 120px;
  }
  .si-i1{
    margin-top: 20px;
    margin-left: 25px;
    height: 21px;
    font-size: 15px;
    font-weight: bold;
    line-height: 21px;
    color: #909DA5;
  }
  .si-i2{
    margin-top: 5px;
    margin-left: 25px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #909DA5;
  }
}
// .c1-item{
//   background: url('../../assets/images/c1@2x.png')no-repeat center;
//   // background-size: cover;
//   background-size: 287px auto;
// }
// .c2-item{
//   background: url('../../assets/images/c2@2x.png')no-repeat center;
//   // background-size: cover;
//   background-size: 287px auto;
// }
// .c3-item{
//   background: url('../../assets/images/c3@2x.png')no-repeat center;
//   // background-size: cover;
//   background-size: 287px auto;
// }
// .c4-item{
//   background: url('../../assets/images/c4@2x.png')no-repeat center;
//   // background-size: cover;
//   background-size: 287px auto;
// }
.floor-item{
  /* border-bottom: solid 1px #EBEEF5; */
}
.floor-item-pro{
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  .floor-item-left{
    h3{
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 21px;
      color: #303133;
    }
  }
  .floor-all-desc{
    padding-top: 26px;
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    color: #606266;
  }
  .fllor-item-right{
    width: 880px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
  }
}
.long-btn{
  display: block;
  border-radius: 20px;
  width: 100%;
}
.newsWrapper{
  padding-top: 25px;
  background-color: #fff;
  .newsPro{
    width: 1180px;
    margin: 0 auto;
    padding-bottom: 20px;
    // padding: 52px 0;
    background: #fff;
  }
  .news-title{
    width: 1180px;
    margin: 0 auto 52px auto;
    font-size: 28px;
    font-weight: 300;
    line-height: 36px;
    color: #0084C4;
    text-indent: 50px;
    background: url('../../assets/images/ico_news@2x.png')no-repeat left center;
    background-size: 24px auto;
  }
  .news-flex{
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    .news-img{
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }
    .news-center{
      width: 980px;
    }
    .news-center-title{
      width: 100%;
      height: 21px;
      font-size: 16px;
      font-weight: bold;
      line-height: 21px;
      color: #000;
      /* color: #8b9fc9; */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .news-desc{
      margin-top: 13px;
      width: 100%;
      height: 38px;
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      overflow: hidden;
      color: #909399;
    }
    .date{
      margin-top: 56px;
      width: 75px;
      height: 19px;
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      color: #909399;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Home/home.vue